// ─── Tipos de acción ─────────────────────────────────────────────────────────
const SAVE_DRAFT  = 'INVENTORY_CART_SAVE_DRAFT';
const CLEAR_DRAFT = 'INVENTORY_CART_CLEAR_DRAFT';

// ─── Estado inicial ───────────────────────────────────────────────────────────
// Movimientos en curso, indexados por pantalla: { [key]: { move } }.
// El centro médico activo no se trackea acá: viaja por fuera en cada request
// (igual que el resto de los slices) y el store entero muere con la página.
const initialState = {};

// ─── Actions ──────────────────────────────────────────────────────────────────
export const inventoryCartDraftActions = {
    saveDraft: (key, move) => ({ type: SAVE_DRAFT, key, move }),
    clearDraft: (key) => ({ type: CLEAR_DRAFT, key }),
};

// ─── Reglas ───────────────────────────────────────────────────────────────────
export function resolveCartDraftKey({ moveType, assignmentType, moveId, assignId }) {
    return [moveType, assignmentType, moveId, assignId].map(toKeyPart).join('|');
}

function toKeyPart(value) {
    if (value == null) return '';
    return typeof value === 'object' ? '' : String(value);
}

export function resolveUsableDraft(draft) {
    return draft?.move ?? null;
}

export function selectCartDraft(state, key) {
    return state.inventoryCartDraft?.[key] ?? null;
}

// El aviso de cambios sin guardar del navegador lo resuelve el confirm nativo de history,
// fuera de todo callback nuestro: la única señal común a las cuatro salidas (aviso aceptado,
// link interno, cancelar, guardar) es que la pantalla efectivamente cambie.
export function leavesCartScreen(mountedPathname, nextLocation) {
    const nextPathname = nextLocation?.pathname ?? null;
    if (mountedPathname == null || nextPathname == null) return false;

    return nextPathname !== mountedPathname;
}

export function resolveDraftAction({
    persistDraft,
    isHydrated,
    isDiscarded,
    isPendingRestore,
    isRestoredStateApplied,
    itemCount
}) {
    if (!persistDraft || !isHydrated || isDiscarded) return 'skip';

    // El carrito rehidratado llega al estado un render después: antes de eso el carrito
    // todavía está vacío y guardarlo o limpiarlo borraría lo que se está restaurando.
    if (isPendingRestore && !isRestoredStateApplied) return 'wait';

    return itemCount > 0 ? 'save' : 'clear';
}

// ─── Reducer ──────────────────────────────────────────────────────────────────
export const reducer = (state, action) => {
    state = state || initialState;

    switch (action.type) {
        case SAVE_DRAFT:
            return { ...state, [action.key]: { move: action.move } };

        case CLEAR_DRAFT: {
            if (state[action.key] === undefined) return state;

            const remaining = { ...state };
            delete remaining[action.key];
            return remaining;
        }

        default:
            return state;
    }
};
